module.exports = __webpack_public_path__ + "img/Chad.196ab5c1.svg";